/*--------------------------------------
SLIDER ABOUT
 --------------------------------------*/
SliderAbout = {
  init: function () {
    var swiper = new Swiper(".swiper-about", {
      pagination: {
        el: ".swiper-pagination",
      },

    });
  }
};


$(function () {
  SliderAbout.init();
});